import React, { useState, useContext } from "react";

import { TextField, Divider, Stack, Button, Box } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSave } from "@fortawesome/free-solid-svg-icons";

import { DataContext } from "../../../context/DataContext";
import { simpleMessage } from "../../../helpers/Helpers";
import { deleteToken, deleteUserData, getToken } from "../../../api/Account";
import { isEmpty } from "lodash";
import { updatePeriodicidadAsync } from "../../../api/Periodicidad";
import { accionPrincipalSx } from "../../../components/ui/accionPrincipal";

const EditPeriodicidad = ({ selected, setShowModal }) => {
  const { id, description, cuotaDias, cantidadDias } = selected;
  const token = getToken();
  const { reload, setReload, setIsLoading, setIsLogged, setIsUnautorized } =
    useContext(DataContext);

  const [newDescription, setNewDescription] = useState(description);
  const [newCantDias, setNewCantDias] = useState(cantidadDias.toString());
  const [newCuotaDias, setNewCuotaDias] = useState(cuotaDias.toString());

  const saveChangesAsync = async () => {
    if (validate()) {
      const data = {
        id,
        description: newDescription,
        cantidadDias: newCantDias,
        cuotaDias: newCuotaDias,
      };

      setIsLoading(true);
      const result = await updatePeriodicidadAsync(token, data);
      if (!result.statusResponse) {
        setIsLoading(false);
        if (result.error === "Unauthorized") {
          setIsUnautorized(true);
          return;
        }
        simpleMessage(result.error, "error");
        return;
      }

      setIsLoading(false);
      simpleMessage("Periodicidad Actualizada...!", "success");
      setReload(!reload);
      setShowModal(false);
    }
  };

  const funtionSetCantidadDias = (value) => {
    if (/^[0-9]+$/.test(value.toString()) || value === "") {
      setNewCantDias(value);
      return;
    }
  };

  //Devuelve un entero positivo
  const funtionSetCuotaDias = (value) => {
    if (/^[0-9]+$/.test(value.toString()) || value === "") {
      setNewCuotaDias(value);
      return;
    }
  };

  //Validando campos ingresados
  const validate = () => {
    let isValid = true;
    if (isEmpty(newDescription)) {
      simpleMessage("Debe ingresar una descripcion", "error");
      return (isValid = false);
    }

    if (isEmpty(newCantDias)) {
      simpleMessage("Debe ingresar una cantidad de días", "error");
      return (isValid = false);
    }

    if (isEmpty(newCuotaDias)) {
      simpleMessage("Debe ingresar cada cuantos días se cobra", "error");
      return (isValid = false);
    }

    if (newCantDias === 0 || newCuotaDias === 0) {
      simpleMessage("Debe ingresar una cantidad mayor que cero", "error");
      return (isValid = false);
    }
    return isValid;
  };

  return (
    <div>
      <Divider />
      <Box sx={{ width: '100%', maxWidth: 450 }}>
        <Stack spacing={2}>
          <TextField
            fullWidth
            required
            onChange={(e) => setNewDescription(e.target.value.toUpperCase())}
            value={newDescription}
            label={"Descripcion Periocidad"}
          />

          <TextField
            fullWidth
            required
            onChange={(e) => funtionSetCantidadDias(e.target.value)}
            value={newCantDias}
            label={"Cantidad de días"}
          />
          <TextField
            fullWidth
            required
            onChange={(e) => funtionSetCuotaDias(e.target.value)}
            value={newCuotaDias}
            label={"Cuota días"}
          />

          <Button
            variant="contained"
            startIcon={
              <FontAwesomeIcon icon={faSave} />
            }
            onClick={() => saveChangesAsync()}
            sx={accionPrincipalSx}
          >
            Guardar Cambios
          </Button>
        </Stack>
      </Box>
    </div>
  );
};

export default EditPeriodicidad;
